import React from 'react';
import { Line } from 'react-konva';
import { useMapEditor } from '../../contexts/MapEditorContext';
import {
  NUMBERING_TOOL_STROKE_COLOR,
  SELECTION_TOOL_STROKE_COLOR
} from '../../defines';

interface SpotLineDrawingProps {
  isDrawing: boolean;
  points: number[];
  onDrawEnd: (hitSpots: { id: string; order: number }[]) => void;
}

export const SpotLineDrawing: React.FC<SpotLineDrawingProps> = ({
  isDrawing,
  points
}) => {
  const { activeTool } = useMapEditor();

  if (!isDrawing || points.length < 4) return null;

  return (
    <Line
      points={points}
      stroke={
        activeTool === 'draw-select'
          ? SELECTION_TOOL_STROKE_COLOR
          : NUMBERING_TOOL_STROKE_COLOR
      }
      strokeWidth={2}
      tension={0.5}
      lineCap="round"
      lineJoin="round"
      dash={[5, 5]}
    />
  );
};
